import { render, staticRenderFns } from "./ResendOrderEmailConfirmationModal.vue?vue&type=template&id=51d6c76e&scoped=true"
import script from "./ResendOrderEmailConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ResendOrderEmailConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./ResendOrderEmailConfirmationModal.vue?vue&type=style&index=0&id=51d6c76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6c76e",
  null
  
)

export default component.exports